/**
 * 搜索热点
 */
"use strict";
angular.module("weiboChannelHotSpotsModule", ['singleSelectCutModule']).
controller("weiboChannelHotSpotsCtrl", ["$scope", "trsHttpService", "$filter", "$state", function($scope, trsHttpService, $filter, $state,) {
    initStatus();
    initData();

    function initStatus() {
        $scope.status = {
            noInfo: false,
            selectedBeginTime: {
                name: '开始时间',
                value: -1
            },
            jumpToPageNum: 1,
            beginTimeList: [],
        }
        $scope.data = {
            weiboData: [],
        }

        $scope.page = {
            "STARTPAGE": 1,
            "PAGESIZE": 10
        };
    }

    function initData() {
        initTimeCut();
        requestWeiboData();
    }

    /**
     * [initTimeCut description]初始化时间段控件
     * @return {[type]} [description]
     */
    function initTimeCut() {
        let hour = $filter("date")(Date.parse(new Date()), "HH");
        for (let i = 23; i >= 0; i--) {
            let name = i < 10 ? ('0' + i) : i;
            let namePlus = i + 1;
            namePlus = namePlus < 10 ? ('0' + namePlus) : namePlus;
            let nameStr = name + ':00-' + namePlus + ':00';
            $scope.status.beginTimeList.unshift({
                name: nameStr,
                value: i
            })

            if (name == hour) {
                $scope.status.selectedBeginTime = {
                    name: nameStr,
                    value: i
                }
            }
            if (i == 0) {
                $scope.status.beginTimeList.unshift({
                    name: '—— 早上 ——',
                    value: 'cut'
                })
            }
            if (i == 12) {
                $scope.status.beginTimeList.unshift({
                    name: '—— 下午 ——',
                    value: 'cut'
                })
            }
            if (i == 17) {
                $scope.status.beginTimeList.unshift({
                    name: '—— 晚上 ——',
                    value: 'cut'
                })
            }
        }
    }  
    /**
     * [requestWeiboData description]获取微博列表数据
     * @return {[type]} [description]
     */
    function requestWeiboData() {
        var params = {
            typeid: "widget",
            serviceid: "weibohotpointmgr",
            modelid: "getWeibohotpoint",
            page_size: $scope.page.PAGESIZE,
            page_no: $scope.page.STARTPAGE-1,
            // hour: '10',
            // search_date:'2019-04-29' // 临时参数
        };
        params.hour = $scope.status.selectedBeginTime.value;
        params.search_date = $filter("date")(Date.parse(new Date()), "yyyy-MM-dd");
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.PAGEITEMS && data.PAGEITEMS.length > 0) {
                $scope.status.noInfo = false;
                $scope.data.weiboData = data.PAGEITEMS;
                $scope.data.curWebHotSpot = $scope.data.weiboData[0];
                $scope.page = {
                    STARTPAGE: data.PAGEINDEX+1,
                    PAGESIZE: data.PAGESIZE,
                    ITEMCOUNT: data.TOTALITEMCOUNT,
                    PAGECOUNT: data.TOTALPAGECOUNT
                }
            } 
            if (data.PAGEITEMS.length == 0){
                $scope.status.noInfo = true;
            }
        });
    }

    /**
     * [selectTimeCallback description]时间回调
     * @return {[type]} [description]
     */
    $scope.selectTimeCallback = function() {
        $scope.data.weiboData = [];
        $scope.data.curWebHotSpot = [];
        $scope.page = {
            "STARTPAGE": 1,
            "PAGESIZE": 10
        };
        requestWeiboData();
    }

    /**
     * [viewWeiboDetail description]查看微博详情
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.viewWeiboDetail = function(item) {
        $state.go("front.plan.hotfocus.channelHotSpots.weibohotspots.channelweibosecond", {batchid:item.BATCHID, eventid: item.EVENTID});
    }

    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.status.jumpToPageNum = $scope.page.STARTPAGE;
        requestWeiboData();
    };

    $scope.jumpToPage = function() {
        if ($scope.status.jumpToPageNum > $scope.page.PAGECOUNT) {
            $scope.status.jumpToPageNum = $scope.page.PAGECOUNT;
        }
        $scope.page.STARTPAGE = $scope.status.jumpToPageNum;
        requestWeiboData();
    };

}]);